import React from 'react'
import SignUpWidget from './sign_up_widget'

function SignUp() {
  return (
    <div>
        <SignUpWidget/>
    </div>
  )
}

export default SignUp